import { useContext, useEffect, useState, useCallback } from "react";
import { toast } from "react-hot-toast";
import { GlobalContext } from "../../../Context/GlobalContext";

/** tiny format helpers kept local */
const fmt = {
  dash: (v) => (v === null || v === undefined || v === "" ? "—" : v),
};

export default function useLogin() {
  const { api, api2, baseUrl, adminId, latitude, longitude } =
    useContext(GlobalContext);

  const [clients, setClients] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState({});

  const setSpin = (id, action) => setBusy((p) => ({ ...p, [id]: action }));
  const clearSpin = (id) => setBusy((p) => ({ ...p, [id]: null }));

  

const adminLogin = async (payload) => {
  try {
    const res = await api.post(
      "/Admin/login",
      payload
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        data: res.data.response || {},
        message:
          res?.data?.responseMessage ||
          "Login successful",
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Login failed",
      };
    }
  } catch (e) {
    console.error("Admin login error:", e);
    return {
      success: false,
      message:
        "Something went wrong!",
    };
  }
};

  return {
    clients,
    orders,
    loading,
    busy,
    adminLogin,
  };
}